module.exports = __webpack_public_path__ + "static/media/students_slide_mobile_2.3c2e1bba.png";